import { render, staticRenderFns } from "./ItemsSummaryMobile.vue?vue&type=template&id=6aaf3cc2&scoped=true"
import script from "./ItemsSummaryMobile.vue?vue&type=script&lang=ts"
export * from "./ItemsSummaryMobile.vue?vue&type=script&lang=ts"
import style0 from "./ItemsSummaryMobile.vue?vue&type=style&index=0&id=6aaf3cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf3cc2",
  null
  
)

export default component.exports